import { baseApi } from "./baseApi";

// FormSections API
export const formSectionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFormSections: builder.query({
      query: (params) => {
        let url = "form_sections";

        url += "?";

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }

        if (params.section_type) {
          url += `section_type=${params.section_type}&`;
        }

        // Remove the trailing '&' if any
        url = url.slice(0, -1);

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }

        return url;
      }
    }),
    createFormSection: builder.mutation({
      query: (formSection) => ({
        url: "form_sections",
        method: "POST",
        body: formSection
      })
    }),
    updateFormSection: builder.mutation({
      query: (params) => ({
        url: `form_sections/${params.id}`,
        method: "PUT",
        body: params.formSection
      })
    }),
    getFormSection: builder.query({
      query: (id) => `form_sections/${id}`
    })
  })
});

// Export mutations and queries
export const {
  useGetFormSectionsQuery,
  useCreateFormSectionMutation,
  useUpdateFormSectionMutation,
  useGetFormSectionQuery,
  useLazyGetFormSectionQuery
} = formSectionApi;
